import { Navigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import useCapabilities from "@/hooks/useCapabilities";
import { useFlagsLoaded } from "@/hooks/useFeatureFlags";
import { useCanAccessPersonBenefits, usePersonBenefitsDefaultTab } from "./_utils";

export default function PersonBenefitsPage() {
  const { pgaId } = useParams();
  const { loaded } = useCapabilities();
  const flagsLoaded = useFlagsLoaded();
  const canAccessBenefits = useCanAccessPersonBenefits();
  const defaultTab = usePersonBenefitsDefaultTab(pgaId ?? "");

  if (!pgaId) return null;
  if (!loaded || !flagsLoaded) return null;
  if (!canAccessBenefits) return null;

  return <Navigate to={defaultTab} replace />;
}
